import React, { useState } from 'react';
import EditEntityForm from './EditEntityForm';
import { Button, Form } from 'antd';

const EditEntity = (props) => {
    const [visible, setVisible] = useState(!!props.forceVisibility);
    const [creationInProgress, toggleCreationInProgress] = useState(false);

    const onSubmit = async (values, form) => {
        toggleCreationInProgress(true);

        const functionToUse = (props.selectedEntity && props.selectedEntity._id != 'new') ? props.editEntity : props.createEntity;
        const responseData = await functionToUse(values);
        console.log('functionToUse response', props.selectedEntity, (props.selectedEntity && props.selectedEntity._id != 'new'), responseData)

        if(typeof responseData.success !== "undefined" && !responseData.success) {
            toggleCreationInProgress(false);
            return;
        } else {
            form.resetFields();
            setVisible(false);
        }

        toggleCreationInProgress(false);

        props.done();
    };

    return (
        <>
            {
                (props.forceVisibility || visible) ?
                <EditEntityForm
                    formSchema={props.formSchema}
                    title={(props.selectedEntity && props.selectedEntity._id != 'new') ? `Update ${props.entityName}` : `Create a new ${props.entityName}`}
                    visible={props.forceVisibility || visible}
                    onSubmit={onSubmit}
                    modalDetails={props.modalDetails}
                    newModalDetails={props.newModalDetails}
                    addEditModalFooter={props.addEditModalFooter}
                    done={props.done}
                    defaultShowAddEditExpandButton={props.defaultShowAddEditExpandButton}
                    creationInProgress={creationInProgress}
                    fetchAllEntities={props.fetchAllEntities}
                    contentClassName={props.contentClassName}
                    defaultValue={props.selectedEntity}
                    onCancel={() => {
                        setVisible(false);
                        props.forceVisibility && props.forceVisibilityCallback();
                        props.onClose();
                    }}
                /> : null
            }

        </>
    );
};

export default EditEntity;